<template>
    <div class="accordion-item review-box" v-show="matchesQuery">
        <h2 class="accordion-header" @click="collapsed = !collapsed" ref="title">
            <button :class="'font-weight-bold accordion-button ' + (collapsed ? 'collapsed' : '')" type="button">
                <slot name="title"></slot>
            </button>
        </h2>
        <div id="collapseOne" :class="'accordion-collapse collapse ' + (collapsed ? '' : 'show')" ref="content">
            <div class="accordion-body bg-light">
                <slot name="text"></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},

    props: {
        query: {default: null},
    },

    mixins: [],

    data: function () {
        return {
            collapsed: true,
            titleText: '',
            contentText: '',
            matchesQuery: false,
            collapsing: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        this.titleText = this.$refs.title.innerText;
        this.contentText = this.$refs.content.innerText;
    },

    methods: {
        checkForMatchInContent() {
            let matchesTitle = this.string_contains_query(this.titleText, this.query);
            let matchesContent = this.string_contains_query(this.contentText, this.query);

            this.matchesQuery = matchesTitle || matchesContent;
        },
        string_contains_query(string, query) {
            if(query === '' || query === null) {
                return true;
            }
            string = string.toLowerCase();
            query = query.toLowerCase();

            // If it's an empty string (meaning it's part of an OR query), return false.
            // This keeps the overview cleaner
            if (query.length < 1) {
                return 0;
            }
            // If there are quotation marks, now's the time to remove them
            query = query.replace(/"/g, "");

            // If there's a single | in there because the user is about to type 2, filter it
            query = query.replace("|", "");

            // If there's an ! in there, it should pass if that name is NOT in there
            if (query.includes('!')) {
                query = query.replace('!', ''); // Replaced the exclamation mark ofcourse
                return this.regexIndexOf(string, query) === -1;
            }
            return this.regexIndexOf(string, query) !== -1;
        },
        regexIndexOf(string, regex_search) {
            // Escape for regex usage. Hier vervangen we alle special characters
            // en escapen ze zodat ze in de regex als string, en niet als modifier gezien worden
            regex_search = regex_search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

            let indexInSuffix = string.search(regex_search);
            return indexInSuffix < 0 ? indexInSuffix : indexInSuffix;
        },
    },

    watch: {
        query: {
            immediate: true,
            handler() {
                this.checkForMatchInContent();
            }
        }
    }
};
</script>
<style lang="scss">
    .review-box {
        h2.accordion-header button {
            font-family: "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
        }
    }
</style>
